
// Global cursor logic
document.addEventListener('DOMContentLoaded', () => {
  const cursorWrapper = document.querySelector('.silhouette-cursor-wrapper');
  const cursor = cursorWrapper?.querySelector('.silhouette-cursor');
  const cursorText = cursor?.querySelector('.silhouette-cursor__text');
  let activeSection = null;

  function onSectionMouseEnter(e) {
    activeSection = e.currentTarget;
    const text = activeSection.getAttribute('data-cursor-animation') || '';
    if (cursorText) cursorText.textContent = text;
    if (cursor) cursor.classList.add('is-active');
    document.body.style.cursor = 'none';
  }

  function onSectionMouseLeave() {
    activeSection = null;
    if (cursor) cursor.classList.remove('is-active');
    document.body.style.cursor = 'auto';
  }

  function onSectionMouseMove(e) {
    if (!cursor || !activeSection) return;
    const x = e.clientX;
    const y = e.clientY;
    cursor.style.transform = `translate(${x}px, ${y}px)`;
  }

  // Seleciona todas as sections que devem ativar o cursor
  document.querySelectorAll('section[data-cursor-animation]').forEach(section => {
    section.addEventListener('mouseenter', onSectionMouseEnter);
    section.addEventListener('mouseleave', onSectionMouseLeave);
    section.addEventListener('mousemove', onSectionMouseMove);
  });

  // Garante que o cursor some ao sair da janela
  document.addEventListener('mouseleave', () => {
    if (cursor) cursor.classList.remove('is-active');
    document.body.style.cursor = 'auto';
  });
});